import {
  ApacCandidateHeader,
  ApacCandidateHeaderFooterLinkProvider,
} from '@seek/apac-candidate-header-footer';

import { useHeaderFooterLinkProvider } from 'src/hooks';
import { useEnableZhForSSR } from 'src/hooks/useEnableZhForSSR';
import { useHeaderProps } from 'src/hooks/useHeaderFooterProps';

const Header = () => {
  const headerLink = useHeaderFooterLinkProvider();
  const {
    authenticationStatus,
    isEnableDivider,
    languageSwitcher,
    onLanguageSwitch,
    returnUrlForPostAuth,
    userProfile,
  } = useHeaderProps();

  const enableZhForSSR = useEnableZhForSSR();

  return (
    <ApacCandidateHeaderFooterLinkProvider value={headerLink}>
      <ApacCandidateHeader
        activePrimaryTab="search"
        authenticationStatus={authenticationStatus}
        divider={isEnableDivider}
        onLanguageSwitch={onLanguageSwitch}
        languageSwitcher={languageSwitcher}
        returnUrlForPostAuth={returnUrlForPostAuth}
        userProfile={userProfile}
        widthMode="large"
        enableZhForSSR={enableZhForSSR}
      />
    </ApacCandidateHeaderFooterLinkProvider>
  );
};

export default Header;
